import { gql } from "@apollo/client";

export const GET_IPS_DEFICIENCIES = gql`
  query PublicIpsDeficiencyPoints {
    getPublicIpsDeficiencyPoints {
      typeCode
      typeDesc
      point
      maxPoint
      ruleName
      reportText
      severity
      daysToCorrect
      lastUpdateDate
      lastUpdateUser
      deactivated
    }
  }
`;